import React, { FC } from 'react';

import { IDynamicComponent, IComponentParams } from 'plugins/api/types';
import { WiseTable } from 'components/wise';
import { dynamicComponentToWiseTableProps } from 'plugins/pages/DynamicPage/adapters/dynamicComponentToWiseTableProps';

import { EditPanel, ListPanel } from 'plugins/components/containers';

import 'plugins/theme/components/EditPanel/EditPanel.scss';

// typ danych wejściowych
interface IProps {
  pageSymbol: string;
  components?: IDynamicComponent[];
  requestParams?: object;
  horizontal?: boolean;
  componentParams?: IComponentParams;
}

const DynamicSwitchComponent: FC<IProps> = ({
  pageSymbol,
  components,
  requestParams,
  componentParams
}) => {
  const renderContent = () => {
    if (components) {
      return components?.map((component, i) => {
        if (component.type === 'tablePanel' || component.type === 'grid') {
          const wiseTableProps = dynamicComponentToWiseTableProps({
            component,
            pageSymbol,
            requestParams,
            componentParams
          });
          return (
            <div key={i} style={{ marginTop: 16 }}>
              <WiseTable {...wiseTableProps} key={i} />
            </div>
          );
        }

        if (component.type === 'editPanel') {
          return (
            <EditPanel
              label={component.label}
              fields={component.fields}
              actions={component.actions}
              isModal={false}
              loadDataParams={component.load_data_params}
              pageSymbol={pageSymbol}
              componentSymbol={component.symbol}
              requestParams={requestParams}
              key={i}
            />
          );
        }

        if (component.type === 'verticalPanel' || component.type === 'listHorizontalPanel') {
          return (
            <ListPanel
              pageSymbol={pageSymbol}
              components={component.components}
              requestParams={requestParams}
              horizontal={component.type === 'listHorizontalPanel'}
              componentParams={componentParams}
              key={i}
            />
          );
        }

        return null;
      });
    }

    return null;
  };

  return <>{renderContent()}</>;
};

export default DynamicSwitchComponent;
